import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom'

import Nav from './components/Nav/Nav'
import Home from './components/Home/Home'
import Summary from './components/Summary/Summary'
import Auth from './components/Auth/Auth'

const App = () => {
    const user = JSON.parse(localStorage.getItem('retailer'))
    return ( 
        <BrowserRouter>
            <Nav />
        <Switch>
            <Route path='/' exact component={ () => ( <Redirect to='/products' /> )} />
            <Route path='/products' exact component={Home} />
            <Route path='/products/search' exact component={Home} />
            <Route path='/auth' exact component={ ()=> ( !user ? <Auth /> : <Redirect to='/products' /> ) } />
            <Route path='/summary' exact component={Summary} />
        </Switch>
        </BrowserRouter>
     );
}
export default App;